import React, { Fragment } from 'react';
import Link from './Link';
const Links = (props) => {
    const { links, className } = props;
    if (!links) {
        return null;
    }
    return (React.createElement(Fragment, null, links.map((link) => (React.createElement(Link, Object.assign({ key: link.url }, link, { className: className }))))));
};
export default Links;
